export default {
  name: 'uz-uz',
  el: {
    breadcrumb: {
      label: 'Breadcrumb', // to be translated
    },
    colorpicker: {
      confirm: 'Qabul qilish',
      clear: 'Tozalash',
      defaultLabel: 'color picker', // to be translated
      description:
        'current color is {color}. press enter to select a new color.', // to be translated
      alphaLabel: 'pick alpha value', // to be translated
      alphaDescription: 'alpha {alpha}, current color is {color}', // to be translated
      hueLabel: 'pick hue value', // to be translated
      hueDescription: 'hue {hue}, current color is {color}', // to be translated
      svLabel: 'pick saturation and brightness value', // to be translated
      svDescription:
        'saturation {saturation}, brightness {brightness}, current color is {color}', // to be translated
      predefineDescription: 'select {value} as the color', // to be translated
    },
    datepicker: {
      now: 'Hozir',
      today: 'Bugun',
      cancel: 'Bekor qilish',
      clear: 'Tozalash',
      confirm: 'Qabul qilish',
      dateTablePrompt:
        'Use the arrow keys and enter to select the day of the month', // to be translated
      monthTablePrompt: 'Use the arrow keys and enter to select the month', // to be translated
      yearTablePrompt: 'Use the arrow keys and enter to select the year', // to be translated
      selectedDate: 'Selected date', // to be translated
      selectDate: 'Kunni tanlash',
      selectTime: 'Soatni tanlash',
      startDate: 'Boshlanish sanasi',
      startTime: 'Boshlanish vaqti',
      endDate: 'Tugash sanasi',
      endTime: 'Tugash vaqti',
      prevYear: 'Oʻtgan yil',
      nextYear: 'Kelgusi yil',
      prevMonth: 'Oʻtgan oy',
      nextMonth: 'Kelgusi oy',
      year: 'Yil',
      month1: 'Yanvar',
      month2: 'Fevral',
      month3: 'Mart',
      month4: 'Aprel',
      month5: 'May',
      month6: 'Iyun',
      month7: 'Iyul',
      month8: 'Avgust',
      month9: 'Sentabr',
      month10: 'Oktabr',
      month11: 'Noyabr',
      month12: 'Dekabr',
      weeks: {
        sun: 'Yak',
        mon: 'Dush',
        tue: 'Sesh',
        wed: 'Chor',
        thu: 'Pay',
        fri: 'Jum',
        sat: 'Shan',
      },
      weeksFull: {
        sun: 'Sunday', // to be translated
        mon: 'Monday', // to be translated
        tue: 'Tuesday', // to be translated
        wed: 'Wednesday', // to be translated
        thu: 'Thursday', // to be translated
        fri: 'Friday', // to be translated
        sat: 'Saturday', // to be translated
      },
      months: {
        jan: 'Yan',
        feb: 'Fev',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Iyun',
        jul: 'Iyul',
        aug: 'Avg',
        sep: 'Sen',
        oct: 'Okt',
        nov: 'Noy',
        dec: 'Dek',
      },
    },
    inputNumber: {
      decrease: 'decrease number', // to be translated
      increase: 'increase number', // to be translated
    },
    select: {
      loading: 'Yuklanmoqda',
      noMatch: 'Mos maʼlumot yoʻq',
      noData: 'Maʼlumot yoʻq',
      placeholder: 'Tanladizngiz',
    },
    mention: {
      loading: 'Yuklanmoqda',
    },
    dropdown: {
      toggleDropdown: 'Toggle Dropdown', // to be translated
    },
    cascader: {
      noMatch: 'Mos maʼlumot topilmadi',
      loading: 'Yuklanmoqda',
      placeholder: 'Tanlash',
      noData: 'Maʼlumot yoʻq',
    },
    pagination: {
      goto: 'Oʻtish',
      pagesize: '/sahifa',
      total: 'Barchasi {total} ta',
      pageClassifier: '',
      page: 'Page', // to be translated
      prev: 'Go to previous page', // to be translated
      next: 'Go to next page', // to be translated
      currentPage: 'page {pager}', // to be translated
      prevPages: 'Previous {pager} pages', // to be translated
      nextPages: 'Next {pager} pages', // to be translated
      deprecationWarning:
        'Deprecated usages detected, please refer to the el-pagination documentation for more details', // to be translated
    },
    dialog: {
      close: 'Close this dialog', // to be translated
    },
    drawer: {
      close: 'Close this dialog', // to be translated
    },
    messagebox: {
      title: 'Xabar',
      confirm: 'Qabul qilish',
      cancel: 'Bekor qilish',
      error: 'Xatolik',
      close: 'Close this dialog', // to be translated
    },
    upload: {
      deleteTip: 'Oʻchirish tugmasini bosib oʻchiring',
      delete: 'Oʻchirish',
      preview: 'Oldin koʻrish',
      continue: 'Davom qilish',
    },
    slider: {
      defaultLabel: 'slider between {min} and {max}', // to be translated
      defaultRangeStartLabel: 'pick start value', // to be translated
      defaultRangeEndLabel: 'pick end value', // to be translated
    },
    table: {
      emptyText: 'Boʻsh',
      confirmFilter: 'Qabul qilish',
      resetFilter: 'Oldingi holatga qaytarish',
      clearFilter: 'Jami',
      sumText: 'Summasi',
    },
    tour: {
      next: 'Next', // to be translated
      previous: 'Previous', // to be translated
      finish: 'Finish', // to be translated
      close: 'Close this dialog', // to be translated
    },
    tree: {
      emptyText: 'Maʼlumot yoʻq',
    },
    transfer: {
      noMatch: 'Mos maʼlumot topilmadi',
      noData: 'Maʼlumot yoʻq',
      titles: ['1-jadval', '2-jadval'],
      filterPlaceholder: 'Kalit soʻzni kiriting',
      noCheckedFormat: '{total} ta element',
      hasCheckedFormat: '{checked}/{total} ta belgilandi',
    },
    image: {
      error: 'Xatolik',
    },
    pageHeader: {
      title: 'Orqaga',
    },
    popconfirm: {
      confirmButtonText: 'Yes', // to be translated
      cancelButtonText: 'No', // to be translated
    },
    carousel: {
      leftArrow: 'Carousel arrow left', // to be translated
      rightArrow: 'Carousel arrow right', // to be translated
      indicator: 'Carousel switch to index {index}', // to be translated
    },
  },
}
